import React, { useMemo } from "react";

export const useStyles = (): React.CSSProperties => {
  return useMemo(
    () => ({
      "--lottie-container-width": "100%",
      "--lottie-container-height": "100%",
      "--lottie-display": "flex",
      "--lottie-align": "center",
      "--lottie-justify": "center",

      "--lottie-width": "100%",
      "--lottie-height": "100%",
    }),
    [],
  ) as React.CSSProperties;
};
